import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'
import { getFirestore } from 'firebase/firestore'

const app = initializeApp({
  apiKey: 'AIzaSyByRR9SfiF2S3b8nbxmB44DEVce8Ok87Ic',
  authDomain: 'bun-alert.firebaseapp.com',
  databaseURL: 'https://bun-alert.firebaseio.com',
  projectId: 'bun-alert',
  storageBucket: 'bun-alert.appspot.com',
  messagingSenderId: '277793136089',
  appId: '1:277793136089:web:aa1cfb0ccbc4b9a4654dc8',
  measurementId: 'G-C6D4EEYWMS',
})

// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('abcdefghijklmnopqrstuvwxy-1234567890abcd'),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true,
})

// Get a Firestore instance
export const db = getFirestore(app)
export const analytics = getAnalytics(app)
